import _ from "lodash";
import { make } from "vuex-pathify";
import loader from "@/util/loader";
import api from "@/util/api";

const initialState = {
    userModel: {
        data: null,
        loader: loader.defaultState(),
    },
    dealModel: {
        data: null,
        loader: loader.defaultState(),
        errorMessage: null,
    },
    originalDealModel: {
        data: null,
        loader: loader.defaultState(),
        errorMessage: null,
    },
    financeCompanies: {
        data: null,
        loader: loader.defaultState(),
    },
    sendDeal: {
        data: null,
        loader: loader.defaultState(),
    },
    scheduleAppointment: {
        data: null,
        loader: loader.defaultState(),
    },
};

const mutations = {
    ...make.mutations(initialState),

    SET_DEAL_MODEL: (state, payload) => {
        state.dealModel.data = payload.data;
        state.dealModel.loader = payload.loader;
        state.dealModel.errorMessage = payload.errorMessage;
    },

    SET_ORIGINAL_DEAL_MODEL: (state, payload) => {
        state.originalDealModel.data = payload.data;
        state.originalDealModel.loader = payload.loader;
        state.originalDealModel.errorMessage = payload.errorMessage;
    },

    SET_USER_MODEL: (state, payload) => {
        state.userModel.data = payload.data;
        state.userModel.loader = payload.loader;
    },

    SET_FINANCE_COMPANIES: (state, payload) => {
        state.financeCompanies.data = payload.data;
        state.financeCompanies.loader = payload.loader;
    },
    SET_SEND_LEAD: (state, payload) => {
        state.sendDeal.data = payload.data;
        state.sendDeal.loader = payload.loader;
    },
    SET_SCHEDULE_APPOINTMENT: (state, payload) => {
        state.scheduleAppointment.data = payload.data;
        state.scheduleAppointment.loader = payload.loader;
    },
};

const actions = {
    resetAppointment({ commit, state }) {
        commit("SET_SCHEDULE_APPOINTMENT", {
            data: null,
            loader: loader.defaultState(),
        });
    },
    resetSendLead({ commit, state }) {
        commit("SET_SEND_LEAD", {
            data: null,
            loader: loader.defaultState(),
        });
    },
    fetchDeal({ commit, state }, { dealId }) {
        commit("SET_DEAL_MODEL", {
            data: null,
            loader: loader.started(),
            errorMessage: null,
        });

        commit("SET_ORIGINAL_DEAL_MODEL", {
            data: null,
            loader: loader.started(),
            errorMessage: null,
        });

        return api
            .get(`/dealer/clone/certificate/${dealId}`)
            .then((response) => {
                commit("SET_DEAL_MODEL", {
                    data: _.get(response, "data", null),
                    loader: loader.successful(),
                    errorMessage: null,
                });
                commit("SET_ORIGINAL_DEAL_MODEL", {
                    data: _.get(response, "data", null),
                    loader: loader.successful(),
                    errorMessage: null,
                });
            })
            .catch((error) => {
                console.log(error);
                commit("SET_DEAL_MODEL", {
                    data: null,
                    loader: loader.error(error),
                });
                commit("SET_ORIGINAL_DEAL_MODEL", {
                    data: null,
                    loader: loader.error(error),
                });
            });
    },
    fetchUser({ commit, state }, { dealerId, userId }) {
        commit("SET_USER_MODEL", {
            data: null,
            loader: loader.started(),
        });
        let params = {};
        if (!_.isNil(dealerId)) {
            params["dealerIds"] = dealerId;
        }
        return api
            .get(`/users/${userId}`, params)
            .then((response) => {
                commit("SET_USER_MODEL", {
                    data: _.get(response, "data", null),
                    loader: loader.successful(),
                });
            })
            .catch((error) => {
                console.log(error);
                commit("SET_USER_MODEL", {
                    data: null,
                    loader: loader.error(error),
                });
            });
    },
    postDeal({ commit, state }, { cloneDealRequest }) {
        commit("SET_DEAL_MODEL", {
            data: cloneDealRequest,
            loader: loader.started(),
            errorMessage: null,
        });
        return api
            .post(`/dealer/clone/update`, cloneDealRequest)
            .then((response) => {
                commit("SET_DEAL_MODEL", {
                    data: _.get(response, "data", null),
                    loader: loader.successful(),
                    errorMessage: null,
                });
                commit("SET_ORIGINAL_DEAL_MODEL", {
                    data: _.get(response, "data", null),
                    loader: loader.successful(),
                    errorMessage: null,
                });
            })
            .catch((error) => {
                console.log(error);
                commit("SET_DEAL_MODEL", {
                    data: null,
                    loader: loader.error(error),
                    errorMessage: error,
                });
            });
    },
    postLead({ commit, state }, { certificateId, formData }) {
        commit("SET_SEND_LEAD", {
            data: null,
            loader: loader.started(),
        });

        return api
            .post(`/deal/${certificateId}/sendLead`, formData)
            .then((response) => {
                commit("SET_SEND_LEAD", {
                    data: _.get(response, "data", null),
                    loader: loader.successful(),
                });
            })
            .catch((error) => {
                console.log(error);
                commit("SET_SEND_LEAD", {
                    data: null,
                    loader: loader.error(error),
                });
            });
    },
    postAppointment({ commit, state }, { certificateId, formData }) {
        commit("SET_SCHEDULE_APPOINTMENT", {
            data: null,
            loader: loader.started(),
        });

        return api
            .post(`/deal/${certificateId}/appointment`, formData)
            .then((response) => {
                commit("SET_SCHEDULE_APPOINTMENT", {
                    data: _.get(response, "data", null),
                    loader: loader.successful(),
                });
            })
            .catch((error) => {
                console.log(error);
                commit("SET_SCHEDULE_APPOINTMENT", {
                    data: null,
                    loader: loader.error(error),
                });
            });
    },
    async recalculateDeal({ commit, state }, recalculateRequest) {
        commit("SET_DEAL_MODEL", {
            data: state.dealModel.data,
            loader: loader.started(),
            errorMessage: null,
        });

        try {
            const response = await api.post(`/dealer/clone/reCalculate`, recalculateRequest);
            commit("SET_DEAL_MODEL", {
                data: _.get(response, "data", null),
                loader: loader.successful(),
                errorMessage: null,
            });
            console.log(response.data);
        } catch (error) {
            let dealModel = {
                // if error set back to original states deal
                data: state.dealModel.data,
                loader: loader.error(error),
                errorMessage: error,
            };

            if (error.response) {
                dealModel.errorMessage = error.response.data;
            }

            commit("SET_DEAL_MODEL", dealModel);
            console.log(error);
            throw error; // re-throw the error to the component
        }
    },
    cancelDeal({ commit, state }) {
        commit("SET_DEAL_MODEL", {
            data: state.originalDealModel.data,
            loader: loader.successful(),
            errorMessage: null,
        });
    },
};

const getters = {
    isEnvironmentProd: () => {
        const environment = _.get(window, "_APP_CONFIG.env[0]", "local") || "local";
        return environment === "prod";
    },
};

export default {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
    getters,
};
